<template>
  <div>
    <div>
      <div>
        <el-select
            v-if="activeTabName === 'deviceManagerTab'"
            v-model="idDevice"
            placeholder="Chọn thiết bị"
            @change="getChangeDeviceRecognition"
            value-key="id"
            style="width: 300px">
          <el-option
              v-for="item in listIdDevice"
              :key="item.id"
              :value="item.id"
              :label="item.nameDevice"
          >
            <span>{{ item.nameDevice }}</span>
          </el-option>
        </el-select>
      </div>
      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <el-tab-pane label="Quản lý thiết bị" name="deviceManagerTab">
          <el-table
              ref="multipleTable"
              :empty-text="textUserDevice"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="listDataUserDevice"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="Họ và tên"
            ></el-table-column>
            <el-table-column label="Ảnh" width="200px" align="center" prop="urlWebFace">
              <template slot-scope="scope">
                <div>
                  <el-image
                      @click="showPictureOnDevice(scope.row.urlWebFace)"
                      :src="scope.row.urlWebFace"
                      style="width: 100%; height: 100%; object-fit: cover;"
                      class="el-image-opacity"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="startTime"
                label="Thời gian bắt đầu"
            ></el-table-column>
            <el-table-column
                prop="endTime"
                label="Thời gian kết thúc"
            ></el-table-column>
            <el-table-column
                label="Tác vụ"
                width="200"
                align="center"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="handleApply(scope.row)"
                >Áp dụng
                </el-button
                >
                <el-button
                    size="mini"
                    @click="handleDelete(scope.row)"
                    type="danger"
                >Xóa
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; display: flex; justify-content: flex-end;">
            <el-menu
                background-color="#67C23A"
                text-color="#FFFFFF"
                active-text-color="#FFFFFF"
                mode="horizontal"
                :unique-opened="true"
                menu-trigger="hover"
            >
              <el-submenu index="1" popper-class="sub_menu" class="sub_menu">
                <template #title>
                  <span>Tác vụ</span>
                </template>
                <el-menu-item index="2" @click="getChangeDeviceRecognition">
                  <template #title>
                    <span>Lấy dữ liệu</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="3" @click="handleOpenSynchronizeDeviceDialog">
                  <template #title>
                    <span>Đồng bộ thiết bị</span>
                  </template>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Cấu hình điểm danh" name="AttendanceConfigTab">
          <div class="attendance-config-container" v-loading="loadingData">
            <el-form :model="configRecognitionResponse" :rules="rules" ref="ruleForm" label-position="top">
              
              <!-- Card 1: Chế độ & Xác thực -->
              <div class="setting-card">
                <div class="setting-card-header">
                  <i class="el-icon-circle-check header-icon"></i>
                  <span>Chế độ & Xác thực điểm danh</span>
                </div>
                <div class="setting-card-body">
                  <!-- Row 1: Chế độ điểm danh -->
                  <div class="setting-row">
                    <div class="setting-info">
                      <div class="setting-title">
                        Chế độ điểm danh, chấm công AI
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.attendanceMode"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="setting-desc">Cấu hình điểm danh bằng AI tự động hoặc xác thực thủ công.</div>
                    </div>
                    <div class="setting-control">
                      <el-radio-group v-model="configRecognitionResponse.attendanceMode" size="medium">
                        <el-radio-button label="manualAndAuto">Tự động</el-radio-button>
                        <el-radio-button label="manual">Thủ công</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>

                  <!-- Row 2: Xác nhận điểm danh, chấm công -->
                  <div class="setting-row">
                    <div class="setting-info">
                      <div class="setting-title">
                        Xác nhận điểm danh, chấm công
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.confirm"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="setting-desc">Yêu cầu người quản lý xác nhận lại kết quả quét được.</div>
                    </div>
                    <div class="setting-control">
                      <el-switch v-model="configRecognitionResponse.confirm"></el-switch>
                    </div>
                  </div>

                  <!-- Row 3: Gửi ảnh đã xác thực -->
                  <div class="setting-row">
                    <div class="setting-info">
                      <div class="setting-title">
                        Gửi ảnh đã xác thực khi điểm danh
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.applyPicture"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="setting-desc">Đính kèm hình ảnh khuôn mặt thực tế khi điểm danh AI.</div>
                    </div>
                    <div class="setting-control">
                      <el-switch v-model="configRecognitionResponse.applyPicture"></el-switch>
                    </div>
                  </div>

                  <!-- Row 4: Điểm danh lại học sinh nghỉ -->
                  <div class="setting-row" v-if="checkPermission(['studentQuality_attendance']) || checkPermission(['studentQuality_attendance_v2'])">
                    <div class="setting-info">
                      <div class="setting-title">
                        Học sinh nghỉ mà đã được xác nhận thì có điểm danh lại không?
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.authenticationWhenAbsent"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="setting-desc">Cho phép thiết bị quét điểm danh lại khi học sinh nghỉ có phép/không phép đã được duyệt trước đó.</div>
                    </div>
                    <div class="setting-control">
                      <el-switch v-model="configRecognitionResponse.authenticationWhenAbsent"></el-switch>
                    </div>
                  </div>

                  <!-- Row 5: Chấm công giáo viên -->
                  <div class="setting-row">
                    <div class="setting-info">
                      <div class="setting-title">
                        Nhân viên có chấm công bằng khuôn mặt hay không?
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.teachersAttendanceWithFaces"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="setting-desc">Bật/Tắt tính năng chấm công nhận diện khuôn mặt cho giáo viên và nhân viên.</div>
                    </div>
                    <div class="setting-control">
                      <el-switch v-model="configRecognitionResponse.teachersAttendanceWithFaces"></el-switch>
                    </div>
                  </div>

                  <!-- Row 6: Tự động xác nhận trong thời gian thủ công -->
                  <div class="setting-row">
                    <div class="setting-info">
                      <div class="setting-title">
                        Tự động xác nhận điểm danh, chẩm công trong thời gian thủ công?
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.manualStillConfirm"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="setting-desc">Bật tự động duyệt chấm công ngay cả ngoài khung giờ tự động cấu hình.</div>
                    </div>
                    <div class="setting-control">
                      <el-switch v-model="configRecognitionResponse.manualStillConfirm"></el-switch>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 2: Cấu hình tham số & Thời gian yêu cầu -->
              <div class="setting-card">
                <div class="setting-card-header">
                  <i class="el-icon-edit-outline header-icon"></i>
                  <span>Thông số tùy chỉnh & Tên hiển thị</span>
                </div>
                <div class="setting-card-body">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="Thời gian tồn tại yêu cầu xác nhận">
                        <div class="input-unit-wrapper">
                          <el-input-number
                              :min="5"
                              :max="20"
                              size="mini"
                              v-model="configRecognitionResponse.attendanceStatusTime"
                              placeholder="Số giây"
                              class="compact-input-number"
                          ></el-input-number>
                          <span class="unit-label">giây</span>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Tên tùy chỉnh xác nhận đến" prop="labelCheckIn">
                        <el-input
                            size="mini"
                            v-model="configRecognitionResponse.labelCheckIn"
                            placeholder="Nhập tên nhãn xác nhận đến"
                            class="modern-input"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Tên tùy chỉnh xác nhận về" prop="labelCheckOut">
                        <el-input
                            size="mini"
                            v-model="configRecognitionResponse.labelCheckOut"
                            placeholder="Nhập tên nhãn xác nhận về"
                            class="modern-input"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <!-- Card 3: Khung thời gian điểm danh tự động -->
              <div class="setting-card">
                <div class="setting-card-header">
                  <i class="el-icon-time header-icon"></i>
                  <span>Khung giờ tự động xác nhận đến / về</span>
                </div>
                <div class="setting-card-body">
                  <div class="time-config-grid">
                    
                    <!-- Khung giờ tự động đến -->
                    <div class="time-block" v-if="checkPermission(['studentQuality_attendance']) || checkPermission(['studentQuality_attendance_v2']) || checkPermission(['attendance_v4'])">
                      <div class="time-block-title">
                        Thời gian tự động xác nhận đến
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" v-html="tooltips.timeAutoArriveHour"></div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                      <div class="time-range-picker-row">
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeAutoArriveHour1"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeAutoArriveMinute1"></el-input-number>
                        </div>
                        <span class="range-arrow">đến</span>
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeAutoArriveHour2"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeAutoArriveMinute2"></el-input-number>
                        </div>
                      </div>
                    </div>

                    <!-- Khung giờ tự động về - Học sinh -->
                    <div class="time-block" v-if="checkPermission(['studentQuality_attendance']) || checkPermission(['attendance_v4'])">
                      <div class="time-block-title">Thời gian tự động xác nhận về cho học sinh</div>
                      <div class="time-range-picker-row">
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeAutoLeaveHour1"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeAutoLeaveMinute1"></el-input-number>
                        </div>
                        <span class="range-arrow">đến</span>
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeAutoLeaveHour2"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeAutoLeaveMinute2"></el-input-number>
                        </div>
                      </div>
                    </div>

                    <!-- Khung giờ tự động về - Giáo viên -->
                    <div class="time-block" v-if="checkPermission(['studentQuality_attendance']) || checkPermission(['studentQuality_attendance_v2'])|| checkPermission(['attendance_v4'])">
                      <div class="time-block-title">Thời gian tự động xác nhận về cho giáo viên</div>
                      <div class="time-range-picker-row">
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeAutoLeaveHourTeacher1"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeAutoLeaveMinuteTeacher1"></el-input-number>
                        </div>
                        <span class="range-arrow">đến</span>
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeAutoLeaveHourTeacher2"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeAutoLeaveMinuteTeacher2"></el-input-number>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 4: Thời gian học các buổi -->
              <div class="setting-card" v-if="checkPermission(['studentQuality_attendance']) || checkPermission(['studentQuality_attendance_v2'])|| checkPermission(['attendance_v4'])">
                <div class="setting-card-header">
                  <i class="el-icon-date header-icon"></i>
                  <span>Khung giờ học các buổi trong ngày</span>
                </div>
                <div class="setting-card-body">
                  <div class="time-config-grid three-cols">
                    <!-- Sáng -->
                    <div class="time-block">
                      <div class="time-block-title blue-badge">Thời gian học buổi sáng</div>
                      <div class="time-range-picker-row">
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.morningSchoolTimeHour1"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.morningSchoolTimeMinute1"></el-input-number>
                        </div>
                        <span class="range-arrow">đến</span>
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.morningSchoolTimeHour2"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.morningSchoolTimeMinute2"></el-input-number>
                        </div>
                      </div>
                    </div>

                    <!-- Chiều -->
                    <div class="time-block">
                      <div class="time-block-title orange-badge">Thời gian học buổi chiều</div>
                      <div class="time-range-picker-row">
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.afternoonSchoolTimeHour1"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.afternoonSchoolTimeMinute1"></el-input-number>
                        </div>
                        <span class="range-arrow">đến</span>
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.afternoonSchoolTimeHour2"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.afternoonSchoolTimeMinute2"></el-input-number>
                        </div>
                      </div>
                    </div>

                    <!-- Tối -->
                    <div class="time-block">
                      <div class="time-block-title purple-badge">Thời gian học buổi tối</div>
                      <div class="time-range-picker-row">
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.eveningSchoolHour1"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.eveningSchoolMinute1"></el-input-number>
                        </div>
                        <span class="range-arrow">đến</span>
                        <div class="time-input-group">
                          <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.eveningSchoolHour2"></el-input-number>
                          <span class="sep">:</span>
                          <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.eveningSchoolMinute2"></el-input-number>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 5: Cấu hình chi tiết theo ca (v2) -->
              <div class="setting-card shift-config-card" v-if="checkPermission(['studentQuality_attendance_v2'])">
                <div class="setting-card-header">
                  <i class="el-icon-document-copy header-icon"></i>
                  <span>Khung giờ tự động xác nhận theo ca học (V2)</span>
                </div>
                <div class="setting-card-body">
                  <div class="shift-grid">
                    
                    <!-- Shift 1: Ca Sáng -->
                    <div class="shift-card-item">
                      <div class="shift-card-header morning">Ca Sáng</div>
                      <div class="shift-card-body">
                        <!-- Đến -->
                        <div class="time-block">
                          <div class="time-block-title">Tự động xác nhận đến</div>
                          <div class="time-range-picker-row">
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeArriveAutoStartShiftMorningHour1"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeArriveAutoStartShiftMorningMinute1"></el-input-number>
                            </div>
                            <span class="range-arrow">đến</span>
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeArriveAutoEndShiftMorningHour2"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeArriveAutoEndShiftMorningMinute2"></el-input-number>
                            </div>
                          </div>
                        </div>
                        <!-- Về -->
                        <div class="time-block">
                          <div class="time-block-title">Tự động xác nhận về</div>
                          <div class="time-range-picker-row">
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeLeaveAutoStartShiftMorningHour1"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeLeaveAutoStartShiftMorningMinute1"></el-input-number>
                            </div>
                            <span class="range-arrow">đến</span>
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeLeaveAutoEndShiftMorningHour2"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeLeaveAutoEndShiftMorningMinute2"></el-input-number>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Shift 2: Ca Chiều -->
                    <div class="shift-card-item">
                      <div class="shift-card-header afternoon">Ca Chiều</div>
                      <div class="shift-card-body">
                        <!-- Đến -->
                        <div class="time-block">
                          <div class="time-block-title">Tự động xác nhận đến</div>
                          <div class="time-range-picker-row">
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeArriveAutoStarShiftAfternoonHour1"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeArriveAutoStarShiftAfternoonMinute1"></el-input-number>
                            </div>
                            <span class="range-arrow">đến</span>
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeArriveAutoEndShiftAfternoonHour2"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeArriveAutoEndShiftAfternoonMinute2"></el-input-number>
                            </div>
                          </div>
                        </div>
                        <!-- Về -->
                        <div class="time-block">
                          <div class="time-block-title">Tự động xác nhận về</div>
                          <div class="time-range-picker-row">
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeLeaveAutoStartShiftAfternoonHour1"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeLeaveAutoStartShiftAfternoonMinute1"></el-input-number>
                            </div>
                            <span class="range-arrow">đến</span>
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeLeaveAutoEndShiftAfternoonHour2"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeLeaveAutoEndShiftAfternoonMinute2"></el-input-number>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Shift 3: Ca Tối -->
                    <div class="shift-card-item">
                      <div class="shift-card-header evening">Ca Tối</div>
                      <div class="shift-card-body">
                        <!-- Đến -->
                        <div class="time-block">
                          <div class="time-block-title">Tự động xác nhận đến</div>
                          <div class="time-range-picker-row">
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeArriveAutoStartShiftEveningHour1"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeArriveAutoStartShiftEveningMinute1"></el-input-number>
                            </div>
                            <span class="range-arrow">đến</span>
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeArriveAutoEndShiftEveningHour2"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeArriveAutoEndShiftEveningMinute2"></el-input-number>
                            </div>
                          </div>
                        </div>
                        <!-- Về -->
                        <div class="time-block">
                          <div class="time-block-title">Tự động xác nhận về</div>
                          <div class="time-range-picker-row">
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeLeaveAutoStartShiftEveningHour1"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeLeaveAutoStartShiftEveningMinute1"></el-input-number>
                            </div>
                            <span class="range-arrow">đến</span>
                            <div class="time-input-group">
                              <el-input-number :min="0" :max="24" size="mini" v-model="configRecognitionResponse.timeLeaveAutoEndShiftEveningHour2"></el-input-number>
                              <span class="sep">:</span>
                              <el-input-number :min="0" :max="59" size="mini" v-model="configRecognitionResponse.timeLeaveAutoEndShiftEveningMinute2"></el-input-number>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Form Actions Bar -->
              <div class="action-footer">
                <el-button type="success" size="medium" @click="onSubmit" :loading="loadingSubmit" class="save-btn">
                  <i class="el-icon-circle-check"></i>
                  Lưu cấu hình
                </el-button>
              </div>

            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog width="30%" :visible.sync="dialogVisibleImg">
      <img width="100%" :src="urlPictureUser" alt/>
    </el-dialog>
    <ApplicableToUsersDialog
        :idUserDeviceRecognition="idUserDeviceRecognition"
        :idDevice="idDevice"
        :showApplicableToUsersDialog="showApplicableToUsersDialog"
        @close="handleCloseApplicableToUsersDialog"
    />
    <SynchronizeDeviceDialog
        :idDeviceOld="idDevice"
        :showSynchronizeDeviceDialog="showSynchronizeDeviceDialog"
        @close="handleSynchronizeDeviceDialog"
        @resume="handleOpenSynchronizeDeviceDialog"
        @synchronized="getDataInit"
    />
  </div>
</template>

<script>

import RecognitionManagerService from "@/services/SchoolService/RecognitionManagerService";
import recognitionManagerService from "@/services/SchoolService/RecognitionManagerService";
import ApplicableToUsersDialog from "@/views/master/school/dialog/ApplicableToUsersDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import SynchronizeDeviceDialog from "@/views/master/school/dialog/SynchronizeDeviceDialog.vue";
import checkPermission from "@/utils/permission";

export default {
  components: {SynchronizeDeviceDialog, ApplicableToUsersDialog},
  data() {
    return {
      activeTabName: "deviceManagerTab",
      listIdDevice: [],
      idDevice: null,
      loadingData: false,
      textUserDevice: this.$tableEmpty,
      listDataUserDevice: [],
      dialogVisibleImg: false,
      urlPictureUser: "",
      showApplicableToUsersDialog: false,
      idUserDeviceRecognition: 0,
      showSynchronizeDeviceDialog: false,
      loadingSubmit: false,
      configRecognitionResponse: {
        labelCheckIn: '',
        labelCheckOut: '',
        timeAutoArriveHour1: 0,
        timeAutoArriveMinute1: 0,
        timeAutoArriveHour2: 0,
        timeAutoArriveMinute2: 0,
        timeAutoLeaveHour1: 0,
        timeAutoLeaveMinute1: 0,
        timeAutoLeaveHour2: 0,
        timeAutoLeaveMinute2: 0,
        timeAutoLeaveHourTeacher1: 0,
        timeAutoLeaveMinuteTeacher1: 0,
        timeAutoLeaveHourTeacher2: 0,
        timeAutoLeaveMinuteTeacher2: 0,
        morningSchoolTimeHour1: 0,
        morningSchoolTimeMinute1: 0,
        morningSchoolTimeHour2: 0,
        morningSchoolTimeMinute2: 0,
        afternoonSchoolTimeHour1: 0,
        afternoonSchoolTimeMinute1: 0,
        afternoonSchoolTimeHour2: 0,
        afternoonSchoolTimeMinute2: 0,
        eveningSchoolHour1: 0,
        eveningSchoolMinute1: 0,
        eveningSchoolHour2: 0,
        eveningSchoolMinute2: 0,
        confirm: false,
        attendanceMode: "disable",
        attendanceStatusTime: 15,
        reqAttendanceStatus: true,
        timeArriveStart: "",
        timeArriveEnd: "",
        timeLeaveStart: "",
        timeLeaveEnd: "",
        timeLeaveStartTeacher: "",
        timeLeaveEndTeacher: "",
        timeArriveMorning: "",
        timeLeaveMorning: "",
        timeArriveAfternoon: "",
        timeLeaveAfternoon: "",
        timeArriveEvening: "",
        timeLeaveEvening: "",

        timeArriveAutoStartShiftMorning: "",
        timeArriveAutoEndShiftMorning: "",
        timeLeaveAutoStartShiftMorning: "",
        timeLeaveAutoEndShiftMorning: "",
        timeArriveAutoStarShiftAfternoon: "",
        timeArriveAutoEndShiftAfternoon: "",
        timeLeaveAutoStartShiftAfternoon: "",
        timeLeaveAutoEndShiftAfternoon: "",
        timeArriveAutoStartShiftEvening: "",
        timeArriveAutoEndShiftEvening: "",
        timeLeaveAutoStartShiftEvening: "",
        timeLeaveAutoEndShiftEvening: "",
        // Thời gian tự động xác nhận đến buổi sáng
        timeArriveAutoStartShiftMorningHour1: 0,
        timeArriveAutoStartShiftMorningMinute1: 0,
        timeArriveAutoEndShiftMorningHour2: 0,
        timeArriveAutoEndShiftMorningMinute2: 0,
        // Thời gian tự động xác nhận về buổi sáng
        timeLeaveAutoStartShiftMorningHour1: 0,
        timeLeaveAutoStartShiftMorningMinute1: 0,
        timeLeaveAutoEndShiftMorningHour2: 0,
        timeLeaveAutoEndShiftMorningMinute2: 0,
        // Thời gian tự động xác nhận đến buổi chiều
        timeArriveAutoStarShiftAfternoonHour1: 0,
        timeArriveAutoStarShiftAfternoonMinute1: 0,
        timeArriveAutoEndShiftAfternoonHour2: 0,
        timeArriveAutoEndShiftAfternoonMinute2: 0,
        // Thời gian tự động xác nhận về buổi chiều
        timeLeaveAutoStartShiftAfternoonHour1: 0,
        timeLeaveAutoStartShiftAfternoonMinute1: 0,
        timeLeaveAutoEndShiftAfternoonHour2: 0,
        timeLeaveAutoEndShiftAfternoonMinute2: 0,
        // Thời gian tự động xác nhận đến buổi tối
        timeArriveAutoStartShiftEveningHour1: 0,
        timeArriveAutoStartShiftEveningMinute1: 0,
        timeArriveAutoEndShiftEveningHour2: 0,
        timeArriveAutoEndShiftEveningMinute2: 0,
        // Thời gian tự động xác nhận về buổi tối
        timeLeaveAutoStartShiftEveningHour1: 0,
        timeLeaveAutoStartShiftEveningMinute1: 0,
        timeLeaveAutoEndShiftEveningHour2: 0,
        timeLeaveAutoEndShiftEveningMinute2: 0,

        applyPicture: false,
        authenticationWhenAbsent: false,
        teachersAttendanceWithFaces: true,
        manualStillConfirm:false

      },
      rules: {
        labelCheckIn: [
          {required: true, message: "Nhập tên tùy chỉnh xác nhận đến", trigger: 'change'}
        ],
        labelCheckOut: [
          {required: true, message: "Nhập tên tùy chỉnh xác nhận về", trigger: 'change'}
        ],
      },
      tooltips: {

        attendanceMode: `
        - <b>Tự động</b>: Hệ thống AI sẽ tự nhận diện khuôn mặt để điểm danh.<br>
        - <b>Thủ công</b>: Người dùng cần xác thực trạng thái đến về trên thiết bị.`,
        confirm: `
        - <b>Bật</b>: Quản lý luôn phải xác nhận trạng thái điểm danh.<br>
        - <b>Tắt</b>: Trong thời gian tự động quản lý không cần xác nhận trạng thái điểm danh.`,
        applyPicture: `
        - <b>Bật</b>: Gửi kèm ảnh khi điểm danh xác thực bằng khuôn mặt.<br>
        - <b>Tắt</b>: Không gửi kèm ảnh khi xác thực bằng khuôn mặt.`,
        authenticationWhenAbsent: `
        - <b>Bật</b>: Cho phép điểm danh lại.<br>
        - <b>Tắt</b>: Không điểm danh lại.`,
        teachersAttendanceWithFaces: `
        - <b>Bật</b>: Cho phép nhân viên xác thực bằng khuôn mặt.<br>
        - <b>Tắt</b>: Không cho phép nhân viên xác thực bằng khuôn mặt.`,
        timeAutoArriveHour: `Thời gian tự động xác nhận đến của toàn bộ học sinh và nhân viên`,
        manualStillConfirm: `
        - <b>Bật</b>: Tự động xác nhận điểm danh chấm công trong thời gian thủ công.<br>
        - <b>Tắt</b>: Không tự động xác nhận điểm danh chấm công trong thời gian thủ công. Vào quản lý điểm danh AI để xác nhận.`,
      }

    };
  },
  created() {
    this.getDataInit()
  },
  methods: {
    checkPermission,
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    showPictureOnDevice(url) {
      this.urlPictureUser = url;
      this.dialogVisibleImg = true;
    },
    /**
     * Khởi tạo dữ liệu
     * @returns {Promise<void>}
     */
    async getDataInit() {
      await this.getListDeviceRecognition();
      await this.getUserFromDeviceSaveToDB();
      await this.getUserFromDevice();
    },
    /**
     * Thay đổi thiết bị
     */
    async getChangeDeviceRecognition() {
      await this.getUserFromDeviceSaveToDB();
      await this.getUserFromDevice();
    },
    /**
     * Lấy danh sách thiết bị
     */
    async getListDeviceRecognition() {
      await RecognitionManagerService.getListDeviceRecognition().then((response) => {
        if (response.data.data.length > 0) {
          this.listIdDevice = response.data.data;
          if (this.listIdDevice.length > 0) {
            this.idDevice = this.listIdDevice[0].id;
          }
        }
      })
    },
    async getUserFromDeviceSaveToDB() {
      await recognitionManagerService.getUserFromDeviceSaveToDB(this.idDevice).then((response) => {
        console.log(response)
      })
    },
    /**
     * Lấy danh sách người dùng có trên thiết bị nhưng chưa có trên db
     */
    async getUserFromDevice() {
      this.loadingData = true;
      await RecognitionManagerService.getUserFromDevice(this.idDevice).then((response) => {
        this.listDataUserDevice = response.data.data;
        this.loadingData = false

      }).catch((error) => {
        console.log(error)
      })
    },

    /**
     * Chuyển màn áp dụng người dùng
     */
    handleApply(row) {
      this.idUserDeviceRecognition = row.id;
      this.showApplicableToUsersDialog = true
    },
    /**
     * Đóng dialog màn áp dụng người dùng
     */
    handleCloseApplicableToUsersDialog() {
      this.showApplicableToUsersDialog = false
      this.getDataInit()
    },

    handleDelete(row) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa người dùng đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        recognitionManagerService.deleteUserFromDevice(row.id).then((response) => {
          if (response.data.data === true) {
            NotifyMessage.leftCornerNotificationSuccess(response.data.message);
          } else {
            NotifyMessage.error(response.data.message);
          }
          this.getDataInit();
        }).catch((error) => {
          console.log(error)
        })
      });
    },

    handleOpenSynchronizeDeviceDialog() {
      this.showSynchronizeDeviceDialog = true
    },
    handleSynchronizeDeviceDialog() {
      this.showSynchronizeDeviceDialog = false
      this.getDataInit()
    },

    handleClickTab(tab) {
      if (tab.name === "deviceManagerTab") {
        this.getDataInit();
      }
      if (tab.name === "AttendanceConfigTab") {
        this.getConfigSchoolService()
      }

    },

    /**
     * Lấy cấu hình điểm danh nhà trường
     */
    async getConfigSchoolService() {
      await recognitionManagerService.findConfigAttendanceSchool().then((response) => {
        Object.assign(this.configRecognitionResponse, response.data.data);
        this.setTimeAutoArrive(this.configRecognitionResponse.timeArriveStart, this.configRecognitionResponse.timeArriveEnd)
        this.setTimeAutoLeave(this.configRecognitionResponse.timeLeaveStart, this.configRecognitionResponse.timeLeaveEnd)
        this.setTimeAutoLeaveTeacher(this.configRecognitionResponse.timeLeaveStartTeacher, this.configRecognitionResponse.timeLeaveEndTeacher)
        this.setMorningSchoolTime(this.configRecognitionResponse.timeArriveMorning, this.configRecognitionResponse.timeLeaveMorning)
        this.setAfternoonSchoolTime(this.configRecognitionResponse.timeArriveAfternoon, this.configRecognitionResponse.timeLeaveAfternoon)
        this.setEveningSchoolTime(this.configRecognitionResponse.timeArriveEvening, this.configRecognitionResponse.timeLeaveEvening)

        this.setTimeArriveAutoShiftMorning(this.configRecognitionResponse.timeArriveAutoStartShiftMorning, this.configRecognitionResponse.timeArriveAutoEndShiftMorning)
        this.setTimeLeaveAutoShiftMorning(this.configRecognitionResponse.timeLeaveAutoStartShiftMorning, this.configRecognitionResponse.timeLeaveAutoEndShiftMorning)
        this.setTimeArriveAutoShiftAfternoon(this.configRecognitionResponse.timeArriveAutoStarShiftAfternoon, this.configRecognitionResponse.timeArriveAutoEndShiftAfternoon)
        this.setTimeLeaveAutoShiftAfternoon(this.configRecognitionResponse.timeLeaveAutoStartShiftAfternoon, this.configRecognitionResponse.timeLeaveAutoEndShiftAfternoon)
        this.setTimeArriveAutoShiftEvening(this.configRecognitionResponse.timeArriveAutoStartShiftEvening, this.configRecognitionResponse.timeArriveAutoEndShiftEvening)
        this.setTimeLeaveAutoShiftShiftEvening(this.configRecognitionResponse.timeLeaveAutoStartShiftEvening, this.configRecognitionResponse.timeLeaveAutoEndShiftEvening)


      }).catch((error) => {
        console.log(error)
      })
    },
    setTimeAutoArrive(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeAutoArriveHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeAutoArriveMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeAutoArriveHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeAutoArriveMinute2 = parseInt(parts2[1]);
    },
    setTimeAutoLeave(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeAutoLeaveHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeAutoLeaveMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeAutoLeaveHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeAutoLeaveMinute2 = parseInt(parts2[1]);
    },
    setTimeAutoLeaveTeacher(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeAutoLeaveHourTeacher1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeAutoLeaveMinuteTeacher1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeAutoLeaveHourTeacher2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeAutoLeaveMinuteTeacher2 = parseInt(parts2[1]);
    },
    setMorningSchoolTime(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.morningSchoolTimeHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.morningSchoolTimeMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.morningSchoolTimeHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.morningSchoolTimeMinute2 = parseInt(parts2[1]);
    },
    setAfternoonSchoolTime(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.afternoonSchoolTimeHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.afternoonSchoolTimeMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.afternoonSchoolTimeHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.afternoonSchoolTimeMinute2 = parseInt(parts2[1]);
    },
    setEveningSchoolTime(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.eveningSchoolHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.eveningSchoolMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.eveningSchoolHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.eveningSchoolMinute2 = parseInt(parts2[1]);
    },

    setTimeArriveAutoShiftMorning(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeArriveAutoStartShiftMorningHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeArriveAutoStartShiftMorningMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeArriveAutoEndShiftMorningHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeArriveAutoEndShiftMorningMinute2 = parseInt(parts2[1]);
    },
    setTimeLeaveAutoShiftMorning(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeLeaveAutoStartShiftMorningHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeLeaveAutoStartShiftMorningMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeLeaveAutoEndShiftMorningHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeLeaveAutoEndShiftMorningMinute2 = parseInt(parts2[1]);
    },

    setTimeArriveAutoShiftAfternoon(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeArriveAutoStarShiftAfternoonHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeArriveAutoStarShiftAfternoonMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeArriveAutoEndShiftAfternoonHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeArriveAutoEndShiftAfternoonMinute2 = parseInt(parts2[1]);
    },
    setTimeLeaveAutoShiftAfternoon(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeLeaveAutoStartShiftAfternoonHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeLeaveAutoStartShiftAfternoonMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeLeaveAutoEndShiftAfternoonHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeLeaveAutoEndShiftAfternoonMinute2 = parseInt(parts2[1]);
    },

    setTimeArriveAutoShiftEvening(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeArriveAutoStartShiftEveningHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeArriveAutoStartShiftEveningMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeArriveAutoEndShiftEveningHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeArriveAutoEndShiftEveningMinute2 = parseInt(parts2[1]);
    },
    setTimeLeaveAutoShiftShiftEvening(startStr, endStr) {
      let parts1 = startStr.split(":");
      let parts2 = endStr.split(":");
      this.configRecognitionResponse.timeLeaveAutoStartShiftEveningHour1 = parseInt(parts1[0]);
      this.configRecognitionResponse.timeLeaveAutoStartShiftEveningMinute1 = parseInt(parts1[1]);
      this.configRecognitionResponse.timeLeaveAutoEndShiftEveningHour2 = parseInt(parts2[0]);
      this.configRecognitionResponse.timeLeaveAutoEndShiftEveningMinute2 = parseInt(parts2[1]);
    },

    async onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        this.loadingSubmit = true
        if (valid) {
          this.configRecognitionResponse.timeArriveStart = this.formatTime(this.configRecognitionResponse.timeAutoArriveHour1,this.configRecognitionResponse.timeAutoArriveMinute1);
          this.configRecognitionResponse.timeArriveEnd = this.formatTime(this.configRecognitionResponse.timeAutoArriveHour2,this.configRecognitionResponse.timeAutoArriveMinute2);
          this.configRecognitionResponse.timeLeaveStart = this.formatTime(this.configRecognitionResponse.timeAutoLeaveHour1,this.configRecognitionResponse.timeAutoLeaveMinute1);
          this.configRecognitionResponse.timeLeaveEnd = this.formatTime(this.configRecognitionResponse.timeAutoLeaveHour2,this.configRecognitionResponse.timeAutoLeaveMinute2);
          this.configRecognitionResponse.timeLeaveStartTeacher = this.formatTime(this.configRecognitionResponse.timeAutoLeaveHourTeacher1,this.configRecognitionResponse.timeAutoLeaveMinuteTeacher1);
          this.configRecognitionResponse.timeLeaveEndTeacher = this.formatTime(this.configRecognitionResponse.timeAutoLeaveHourTeacher2,this.configRecognitionResponse.timeAutoLeaveMinuteTeacher2);
          this.configRecognitionResponse.timeArriveMorning = this.formatTime(this.configRecognitionResponse.morningSchoolTimeHour1,this.configRecognitionResponse.morningSchoolTimeMinute1);
          this.configRecognitionResponse.timeLeaveMorning = this.formatTimeLate(this.configRecognitionResponse.morningSchoolTimeHour2,this.configRecognitionResponse.morningSchoolTimeMinute2);
          this.configRecognitionResponse.timeArriveAfternoon = this.formatTime(this.configRecognitionResponse.afternoonSchoolTimeHour1,this.configRecognitionResponse.afternoonSchoolTimeMinute1);
          this.configRecognitionResponse.timeLeaveAfternoon = this.formatTimeLate(this.configRecognitionResponse.afternoonSchoolTimeHour2,this.configRecognitionResponse.afternoonSchoolTimeMinute2);
          this.configRecognitionResponse.timeArriveEvening = this.formatTime(this.configRecognitionResponse.eveningSchoolHour1,this.configRecognitionResponse.eveningSchoolMinute1);
          this.configRecognitionResponse.timeLeaveEvening = this.formatTimeLate(this.configRecognitionResponse.eveningSchoolHour2,this.configRecognitionResponse.eveningSchoolMinute2);

          this.configRecognitionResponse.timeArriveAutoStartShiftMorning = this.formatTime(this.configRecognitionResponse.timeArriveAutoStartShiftMorningHour1,this.configRecognitionResponse.timeArriveAutoStartShiftMorningMinute1);
          this.configRecognitionResponse.timeArriveAutoEndShiftMorning = this.formatTimeLate(this.configRecognitionResponse.timeArriveAutoEndShiftMorningHour2,this.configRecognitionResponse.timeArriveAutoEndShiftMorningMinute2);

          this.configRecognitionResponse.timeLeaveAutoStartShiftMorning = this.formatTime(this.configRecognitionResponse.timeLeaveAutoStartShiftMorningHour1,this.configRecognitionResponse.timeLeaveAutoStartShiftMorningMinute1);
          this.configRecognitionResponse.timeLeaveAutoEndShiftMorning = this.formatTimeLate(this.configRecognitionResponse.timeLeaveAutoEndShiftMorningHour2,this.configRecognitionResponse.timeLeaveAutoEndShiftMorningMinute2);

          this.configRecognitionResponse.timeArriveAutoStarShiftAfternoon = this.formatTime(this.configRecognitionResponse.timeArriveAutoStarShiftAfternoonHour1,this.configRecognitionResponse.timeArriveAutoStarShiftAfternoonMinute1);
          this.configRecognitionResponse.timeArriveAutoEndShiftAfternoon = this.formatTimeLate(this.configRecognitionResponse.timeArriveAutoEndShiftAfternoonHour2,this.configRecognitionResponse.timeArriveAutoEndShiftAfternoonMinute2);

          this.configRecognitionResponse.timeLeaveAutoStartShiftAfternoon = this.formatTime(this.configRecognitionResponse.timeLeaveAutoStartShiftAfternoonHour1,this.configRecognitionResponse.timeLeaveAutoStartShiftAfternoonMinute1);
          this.configRecognitionResponse.timeLeaveAutoEndShiftAfternoon = this.formatTimeLate(this.configRecognitionResponse.timeLeaveAutoEndShiftAfternoonHour2,this.configRecognitionResponse.timeLeaveAutoEndShiftAfternoonMinute2);

          this.configRecognitionResponse.timeArriveAutoStartShiftEvening = this.formatTime(this.configRecognitionResponse.timeArriveAutoStartShiftEveningHour1,this.configRecognitionResponse.timeArriveAutoStartShiftEveningMinute1);
          this.configRecognitionResponse.timeArriveAutoEndShiftEvening = this.formatTimeLate(this.configRecognitionResponse.timeArriveAutoEndShiftEveningHour2,this.configRecognitionResponse.timeArriveAutoEndShiftEveningMinute2);

          this.configRecognitionResponse.timeLeaveAutoStartShiftEvening = this.formatTime(this.configRecognitionResponse.timeLeaveAutoStartShiftEveningHour1,this.configRecognitionResponse.timeLeaveAutoStartShiftEveningMinute1);
          this.configRecognitionResponse.timeLeaveAutoEndShiftEvening = this.formatTimeLate(this.configRecognitionResponse.timeLeaveAutoEndShiftEveningHour2,this.configRecognitionResponse.timeLeaveAutoEndShiftEveningMinute2);

          recognitionManagerService.updateConfigAttendanceSchool(this.configRecognitionResponse).then((res) => {
            if (res.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess(res.data.message);
            } else {
              NotifyMessage.leftCornerNotificationError(res.data.message);
            }
          }).catch((error) => {
            console.log(error)
          }).finally(
              this.loadingSubmit = false
          )
        } else {
          this.loadingSubmit = false
        }
      });
    },

    formatTime(hour, minute) {
       return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00`;
    },

    formatTimeLate(hour, minute) {
      return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:59`;
    },
},

};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}


.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}


.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;

}

td {
  padding: 12px;
}

.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

/deep/ .el-table .cell {
  overflow-y: auto !important;
  white-space: pre-line;
  line-height: 20px;
  word-break: break-word;
  max-height: 156px !important;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.sub_menu {
  /deep/ .el-submenu__title {
    height: 40px;
    display: flex;
    align-items: center;
  }

  /deep/ i {
    color: #FFFFFF;
    margin-top: 0 !important;
  }
}
.el-dropdown-menu {
  position: absolute;
  background-color: #5fb44a;
  border-radius: 0;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

// Attendance Configuration Tab Styling
.attendance-config-container {
  padding: 24px;
  background-color: #f8fafc;
  border-radius: 12px;
  margin-top: 15px;
}

.setting-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  }
}

.setting-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 14px;
  margin-bottom: 20px;
  
  .header-icon {
    color: #3b82f6;
    font-size: 18px;
  }
}

.setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px dashed #e2e8f0;
  
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  
  &:first-child {
    padding-top: 0;
  }
}

.setting-info {
  flex: 1;
  padding-right: 24px;
}

.setting-title {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  .help-icon {
    color: #94a3b8;
    cursor: pointer;
    font-size: 14px;
    transition: color 0.2s;
    
    &:hover {
      color: #3b82f6;
    }
  }
}

.setting-desc {
  font-size: 12px;
  color: #64748b;
  margin-top: 6px;
  line-height: 1.4;
}

.input-unit-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.unit-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

/deep/ .el-form-item {
  margin-bottom: 0;
  
  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    font-size: 13px;
    padding-bottom: 6px !important;
  }
}

.modern-input {
  /deep/ .el-input__inner {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #334155;
    font-weight: 500;
    height: 38px;
    line-height: 38px;
    transition: all 0.25s ease;
    
    &:focus {
      border-color: #3b82f6;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
}

.time-config-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  &.three-cols {
    grid-template-columns: repeat(3, 1fr);
  }
}

.time-block {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.25s ease;
  
  &:hover {
    background: #ffffff;
    border-color: #e2e8f0;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  }
}

.time-block-title {
  font-weight: 600;
  font-size: 13px;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &.blue-badge::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #3b82f6;
    border-radius: 9999px;
  }
  
  &.orange-badge::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #f97316;
    border-radius: 9999px;
  }
  
  &.purple-badge::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #a855f7;
    border-radius: 9999px;
  }
  
  .help-icon {
    color: #94a3b8;
    font-size: 14px;
    cursor: pointer;
    
    &:hover {
      color: #3b82f6;
    }
  }
}

.time-range-picker-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.time-input-group {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px 8px;
  
  /deep/ .el-input-number--mini {
    width: 54px;
    
    .el-input-number__decrease,
    .el-input-number__increase {
      display: none;
    }
    
    .el-input__inner {
      padding: 0 !important;
      border: none;
      text-align: center;
      font-weight: 600;
      color: #334155;
      background: transparent;
    }
  }
}

.sep {
  font-weight: 700;
  color: #94a3b8;
  font-size: 14px;
}

.range-arrow {
  color: #3b82f6;
  font-weight: 600;
  font-size: 12px;
}

// Shift Grid
.shift-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.shift-card-item {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.01);
  transition: all 0.25s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.03);
  }
}

.shift-card-header {
  padding: 10px 16px;
  font-weight: 700;
  font-size: 13px;
  text-align: center;
  
  &.morning {
    background: #eff6ff;
    color: #1d4ed8;
    border-bottom: 1px solid #dbeafe;
  }
  
  &.afternoon {
    background: #fff7ed;
    color: #c2410c;
    border-bottom: 1px solid #ffedd5;
  }
  
  &.evening {
    background: #faf5ff;
    color: #7e22ce;
    border-bottom: 1px solid #f3e8ff;
  }
}

.shift-card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  .time-block {
    padding: 0;
    background: transparent;
    border: none;
    
    &:hover {
      box-shadow: none;
    }
  }
}

.action-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
}

.save-btn {
  min-width: 160px;
  height: 42px;
  font-weight: 600;
  border-radius: 10px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  i {
    margin-right: 4px;
  }
}
</style>
